const DescriptionIcon = () => (
  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.999 8.37551C19.999 12.8635 15.5227 16.5 9.9996 16.5C8.55047 16.5 7.17555 16.25 5.93343 15.8009C5.46861 16.1407 4.71085 16.6055 3.81246 16.9961C2.87502 17.4023 1.74617 17.75 0.625146 17.75C0.371254 17.75 0.144705 17.5976 0.0470541 17.3633C-0.0505965 17.1289 0.00408779 16.8633 0.179859 16.6836L0.191577 16.6719C0.203295 16.6602 0.218919 16.6446 0.242355 16.6172C0.285322 16.5703 0.351724 16.4961 0.43375 16.3946C0.593897 16.1993 0.808729 15.9102 1.02747 15.5509C1.41807 14.9025 1.78914 14.051 1.86336 13.094C0.691548 11.7659 0.000181773 10.1371 0.000181773 8.37551C0.000181773 3.88748 4.47649 0.250977 9.9996 0.250977C15.5227 0.250977 19.999 3.88748 19.999 8.37551Z"
      fill="black"
    />
  </svg>
);

export default DescriptionIcon;
